import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./layouts/Layout";
import Home from "./pages/Home";
import OurStory from "./pages/Our_Story";
import Services from "./pages/Services";
import Book from "./pages/Book";
import Work from "./pages/Work";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Copyright from "./pages/Copyright";
import FAQ from "./pages/FAQ";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// Component to handle old category URL redirects
function CategoryRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/', { replace: true });
  }, [navigate]);

  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="work" element={<Work />} />
          <Route path="our_story" element={<OurStory />} />
          <Route path="services" element={<Services/>} />
          <Route path="book" element={<Book/>} />
          <Route path="privacy" element={<Privacy />} />
          <Route path="terms" element={<Terms />} />
          <Route path="faq" element={<FAQ />} />
          <Route path="copyright" element={<Copyright />} />
          {/* Redirect old category URLs to homepage */}
          <Route path="category/*" element={<CategoryRedirect />} />
          {/* Catch-all 404 redirect to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
